'use client';

import type { FC } from 'react';
import type { PromotionTallBannerItemType } from '@weberus/shared-types';
import { BaseImage } from '@/app/_components/common/base-image';

export interface PromotionTallBannerItemProps extends PromotionTallBannerItemType {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const PromotionTallBannerItem: FC<PromotionTallBannerItemProps> = (props) => {
  const { onClick, image } = props;

  return (
    <a
      href={props.action.web}
      className="item-center flex max-w-full justify-center pc:w-[305px]"
      onClick={(e) => onClick?.(e)}>
      <div className="relative mx-auto aspect-[2/3] size-full overflow-hidden rounded-[16px]">
        <BaseImage alt={props.logMeta.specialPriceNowItemTitle} className="object-center" src={image.url} />
      </div>
    </a>
  );
};
